const SquareShimmer = () => {
  return (
    <div className="relative w-full h-full overflow-hidden rounded-lg bg-gray-200">
      <div className="shimmer absolute inset-0" />
    </div>
  );
};

export default SquareShimmer;
